import { ComponentRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalTooltipComponent } from './modal-tooltip.component';

export class ModalTooltip {
  modalRef: ComponentRef<ModalTooltipComponent>;
  contentRef: ComponentRef<any>;
  closed$ = new Subject<void>();

  close(): void {
    this.onClose();
    this.closed$.next();
    this.closed$.complete();
  }

  setOnCloseMethod(fn: () => void): void {
    this.onClose = fn;
  }

  setContentRef(contentRef: ComponentRef<any>): void {
    this.contentRef = contentRef;
  }

  setModalRef(modalRef: ComponentRef<ModalTooltipComponent>): void {
    this.modalRef = modalRef;
  }

  private onClose(): void {}
}
